// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import eventEntity from './entities/event.json';
import eventMenu from '../pages/event/menu.json';
import eventFullForm from '../pages/event/forms/full.json';
import eventContextForm from '../pages/event/forms/context.json';
import eventMiniForm from '../pages/event/forms/mini.json';
import eventLookupForm from '../pages/event/forms/lookup.json';
import eventTableView from '../pages/event/views/table.json';
import eventStagesView from '../pages/event/views/stages.json';
import eventCardsView from '../pages/event/views/cards.json';
import eventSplitView from '../pages/event/views/split.json';
import eventCalendarView from '../pages/event/views/calendar.json';
import eventDashboardView from '../pages/event/views/dashboard.json';

/** Тип запису «Подія» зі сторінками пакета: меню, форми та подання з pages/event/. */
export const eventDefinition: IRecordTypeDefinition = {
  ...eventEntity,
  views: assembleViewSet({
      table: eventTableView,
      stages: eventStagesView,
      cards: eventCardsView,
      split: eventSplitView,
      calendar: eventCalendarView,
      dashboard: eventDashboardView,
  }),
  form: eventFullForm,
  forms: { full: eventFullForm, context: eventContextForm, mini: eventMiniForm, lookup: eventLookupForm },
  menu: eventMenu,
} as IRecordTypeDefinition;
